import logo from './logo.svg';
import './App.css';
import { IntlProvider } from 'react-intl';
import { loadLocale } from './locale/index';
import Routers from "./router";
import { useEffect, useMemo, useState } from 'react';
import { useLocation  } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { ConfigProvider as MobileConfigProvider } from 'antd-mobile';
import dayjs from 'dayjs';

import 'dayjs/locale/zh-hk';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/pt';

import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import updateLocale from 'dayjs/plugin/updateLocale';
// 可选：格式/解析更完善
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(updateLocale);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

function App() {

  const {pathname, search} = useLocation ()
  const [localeName, setLocaleName] = useState('');
  const [localeReady, setLocaleReady] = useState(false);

  const { locale, antdLocale, mobileLocale, message } = useMemo(() => {
    if(localeName) {
      setLocaleReady(true);
      return loadLocale(localeName);
    }
    else {
      return loadLocale('global')
    }
  }, [localeName]);

  useEffect(() => {
    if (locale) {
      dayjs.locale(locale.toLowerCase());
    }
  }, [locale]);

  useEffect(()=>{
    const pattern = /\/warranty\/[a-zA-Z0-9\-._~]+\/form/;
    const pattern2 = /\/event\/[A-Za-z0-9-]+(\/[A-Za-z0-9-]+)*\.html$/;
    if((pattern.test(pathname) || pattern2.test(pathname) || pathname.includes('/check_period/warranty')) && search) {
      const params = new URLSearchParams(search);
      const languageId = params.get('language');
      const formCode = params.get('code');
      setLocaleName(languageId || 'global');
      localStorage.setItem("formCode", formCode || 'default');
      localStorage.setItem("localeName", languageId || 'global');
    }
    else {
      setLocaleReady(true);
    }
  }, [search, pathname])

  return !localeReady ? null : (
    <ConfigProvider locale={antdLocale}>
      <MobileConfigProvider locale={mobileLocale}>
        <IntlProvider locale={locale} messages={message} onError={()=>{}}>
          <Routers localeName={localeName}/>
        </IntlProvider>
      </MobileConfigProvider>
    </ConfigProvider>
  );
}

export default App;
